/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDocument } from './PatientDocument';
import {
    PatientDocumentFromJSON,
    PatientDocumentFromJSONTyped,
    PatientDocumentToJSON,
    PatientDocumentToJSONTyped,
} from './PatientDocument';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * Document-CCL link enriched with resolved PatientDocument data
 * @export
 * @interface DocCcl
 */
export interface DocCcl {
    /**
     * 
     * @type {number}
     * @memberof DocCcl
     */
    documentCclId?: number;
    /**
     * 
     * @type {number}
     * @memberof DocCcl
     */
    conclusionGroupId: number;
    /**
     * 
     * @type {number}
     * @memberof DocCcl
     */
    patientDocumentId: number;
    /**
     * 
     * @type {number}
     * @memberof DocCcl
     */
    documentOrder: number;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof DocCcl
     */
    id: UiIdentifier;
    /**
     * originalText of the PatientDocument
     * @type {string}
     * @memberof DocCcl
     */
    text: string;
    /**
     * Resolved icon key: file | pencil | fileCheck
     * @type {string}
     * @memberof DocCcl
     */
    icon: string;
    /**
     * 
     * @type {PatientDocument}
     * @memberof DocCcl
     */
    documentExpression?: PatientDocument;
}

/**
 * Check if a given object implements the DocCcl interface.
 */
export function instanceOfDocCcl(value: object): value is DocCcl {
    if (!('conclusionGroupId' in value) || value['conclusionGroupId'] === undefined) return false;
    if (!('patientDocumentId' in value) || value['patientDocumentId'] === undefined) return false;
    if (!('documentOrder' in value) || value['documentOrder'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function DocCclFromJSON(json: any): DocCcl {
    return DocCclFromJSONTyped(json, false);
}

export function DocCclFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocCcl {
    if (json == null) {
        return json;
    }
    return {
        
        'documentCclId': json['documentCclId'] == null ? undefined : json['documentCclId'],
        'conclusionGroupId': json['conclusionGroupId'],
        'patientDocumentId': json['patientDocumentId'],
        'documentOrder': json['documentOrder'],
        'id': UiIdentifierFromJSON(json['id']),
        'text': json['text'],
        'icon': json['icon'],
        'documentExpression': json['documentExpression'] == null ? undefined : PatientDocumentFromJSON(json['documentExpression']),
    };
}

export function DocCclToJSON(json: any): DocCcl {
    return DocCclToJSONTyped(json, false);
}

export function DocCclToJSONTyped(value?: DocCcl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentCclId': value['documentCclId'],
        'conclusionGroupId': value['conclusionGroupId'],
        'patientDocumentId': value['patientDocumentId'],
        'documentOrder': value['documentOrder'],
        'id': UiIdentifierToJSON(value['id']),
        'text': value['text'],
        'icon': value['icon'],
        'documentExpression': PatientDocumentToJSON(value['documentExpression']),
    };
}

